module.exports = __webpack_public_path__ + "media/slow-spring-board.9cc67f8c.mp3";